import type { FecImportItem } from '../query-api'
import { isFecConfirmationIncomplete } from './isFecConfirmationIncomplete'
import { shouldConfirmFecThirdParties } from './shouldConfirmFecThirdParties'

type FecMappingsToConfirmFields = Pick<
  FecImportItem,
  | 'accountMappingStatus'
  | 'accountPushStatus'
  | 'entryPushStatus'
  | 'journalMappingStatus'
  | 'journalPushStatus'
  | 'thirdPartyMappingStatus'
  | 'thirdPartyPushStatus'
>

/**
 * Whether any import still has something for the confirm to send: a domain (journals, accounts or third parties)
 * that is open, or an opening-balance entry push that failed or has not run.
 */
export const hasFecMappingsToConfirm = (fecImports: FecMappingsToConfirmFields[]): boolean =>
  fecImports.some(
    (fecImport) =>
      isFecConfirmationIncomplete(fecImport.journalMappingStatus, fecImport.journalPushStatus) ||
      isFecConfirmationIncomplete(fecImport.accountMappingStatus, fecImport.accountPushStatus) ||
      shouldConfirmFecThirdParties(fecImport),
  )
